module.exports = __webpack_public_path__ + "static/img/1.889b7fb5.jpg";